import { FileUploadSetting } from 'backend';
import {
  FILE_UPLOAD_ERROR_MESSAGE_KEY,
  isFileUploadSessionExpired,
  toLowerCamelCaseErrorType,
} from 'models';
import { FileUploadProperty } from 'shared';
import { FileUploadSessionStateReady } from 'store';

type ValidationFilePayload = {
  file: File;
  fileUploadSetting: FileUploadSetting;
  session: FileUploadSessionStateReady;
  property: FileUploadProperty;
};

export type ValidationFileResult = {
  errorMessages: string[];
  errorTypes: string[];
};

export const validationFile = ({
  file,
  fileUploadSetting,
  session,
  property,
}: ValidationFilePayload): ValidationFileResult => {
  const { allowedFileExtensions } = property.inputFormat;
  const { fileSizeLimit } = property.inputFormat;
  const {
    UNACCEPTABLE_MEDIA_FORMAT,
    FILE_EMPTY,
    FILE_SIZE_TOO_LARGE,
    API_ACCESS_DENIED,
  } = fileUploadSetting.errorMessages;
  const expired = isFileUploadSessionExpired(session);
  if (expired) {
    return {
      errorMessages: [API_ACCESS_DENIED],
      errorTypes: [
        toLowerCamelCaseErrorType(
          FILE_UPLOAD_ERROR_MESSAGE_KEY.API_ACCESS_DENIED,
        ),
      ],
    };
  }
  const allowedExtensions = allowedFileExtensions.map((ext) =>
    ext.toLowerCase(),
  );
  const extension = file.name.split('.').slice().pop();
  const invalidExtension =
    extension == null || !allowedExtensions.includes(extension.toLowerCase());
  const errorMessages = [];
  const errorTypes = [];
  if (invalidExtension) {
    errorMessages.push(UNACCEPTABLE_MEDIA_FORMAT);
    errorTypes.push(
      toLowerCamelCaseErrorType(
        FILE_UPLOAD_ERROR_MESSAGE_KEY.UNACCEPTABLE_MEDIA_FORMAT,
      ),
    );
  }

  const fileSizeIsZero = file.size === 0;
  if (fileSizeIsZero) {
    errorMessages.push(FILE_EMPTY);
    errorTypes.push(
      toLowerCamelCaseErrorType(FILE_UPLOAD_ERROR_MESSAGE_KEY.FILE_EMPTY),
    );
  }

  // MBに変換
  const fileSizeIsTooLarge = file.size > fileSizeLimit * 1000 * 1000;
  if (fileSizeIsTooLarge) {
    errorMessages.push(FILE_SIZE_TOO_LARGE);
    errorTypes.push(
      toLowerCamelCaseErrorType(
        FILE_UPLOAD_ERROR_MESSAGE_KEY.FILE_SIZE_TOO_LARGE,
      ),
    );
  }

  return {
    errorMessages,
    errorTypes,
  };
};
